import { InventoryStockTypes } from '@/store/types'

export default {
  filters: {
    formatStockType: function (stockType) {
      switch(stockType) {
        case InventoryStockTypes.glass: return 'Glass'
        case InventoryStockTypes.glassService: return 'Glass Service'
        case InventoryStockTypes.template: return 'Template'
        case InventoryStockTypes.general: return 'General'
        case InventoryStockTypes.assembly: return 'Assembly'
      }
      return stockType      
    }
  }
}
